import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useAdminMerchant = (id: string) => {
  return useQuery({
    queryKey: ["admin", "merchant", id],
    queryFn: async () => {
      const res = await client.admin.merchant[":id"].$get({ param: { id } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!id,
  });
};
